import React, {FunctionComponent} from 'react';
import './InvoiceItemRowFilePreview.scss';
import {File} from "../../../models/file.model";

export interface InvoiceItemRowFileProps {
    file: File;
    onViewImage: (file: File) => void;
}

export const InvoiceItemRowFilePreview: FunctionComponent<InvoiceItemRowFileProps> = (props) => {
    const {file} = props;

    const onViewImage = () => {
        props.onViewImage(file)
    }

    return <img className="invoice-item-row-file-preview" src={file.url} alt={file.display_name} onClick={onViewImage}/>
};
